import { render, staticRenderFns } from "./NotAuth.vue?vue&type=template&id=616471a4"
import script from "./NotAuth.vue?vue&type=script&lang=js"
export * from "./NotAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports